import Container from "@mui/material/Container";


export default function ContentContainer({ width, children}) {
    return <Container
        id='content-container'
        component="main"
        maxWidth={ width? width:"xs"}
        sx={{
            boxShadow: 3,
            padding: 2,
            borderRadius: 2,
            marginTop: 3,
            marginBottom: 5,
            backgroundColor: '#fff'
        }}
    >
        {children}
    </Container>
}